// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"48":"1fcbeea548934d4e","227":"5f1e3e753e308a84","338":"b2c245510a183a29","561":"13f9dfc8fdd48ca5","785":"b7679421659a7cd0"}[chunkId] + ".css";
};